import React from 'react';

export const Header = (props) => {
  return (
    <header id='header'>
      <div className='container'>
        <p>
          Water Purifier Repair &amp; Home Visit Charge - ₹299/- | Installation Charges - ₹499/- in Hyderabad. Call - 6305399931
        </p>
      </div>
    </header>
  )
}
